import { render, staticRenderFns } from "./CCRUploads.vue?vue&type=template&id=49a559d2&"
import script from "./CCRUploads.vue?vue&type=script&lang=js&"
export * from "./CCRUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports